import { render, staticRenderFns } from "./LaowaiSurvivalGame.vue?vue&type=template&id=79bcdd9b&scoped=true&"
import script from "./LaowaiSurvivalGame.vue?vue&type=script&lang=js&"
export * from "./LaowaiSurvivalGame.vue?vue&type=script&lang=js&"
import style0 from "./LaowaiSurvivalGame.vue?vue&type=style&index=0&id=79bcdd9b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79bcdd9b",
  null
  
)

export default component.exports